import DefaultTemplate from "./Templates/DefaultTemplate";
import GridTemplate from "./Templates/GridTemplate";
import ListTemplate from "./Templates/ListTemplate";
import { useConfig } from "../../../data/useConfig";
import { useFilters } from "../../../data/useFilters";
import SeeAllResultsButton from "./SeeAllResultsButton";
import { dispatchGA4SearchEvent } from "../../../utils/events";
import {
  AutocompleteContainer,
  AutocompleteHeader,
  AutocompleteHeaderText,
} from "./styles";

const Autocomplete = ({
  clearSearchHistory,
  inputValue,
  isFocused,
  onSearch,
  onSearchValue,
  saveSearchActionOnStorage,
  suggestedTerms,
  tenantsWithHistory,
  withDynamicRegion,
}) => {
  const { anchorsApplied } = useFilters();
  const { autocompleteConfigs } = useConfig();
  const autocompleteLayout = autocompleteConfigs?.layout || "default";

  const onSuggestionClick = ({ label, params, value }) => {
    dispatchGA4SearchEvent({
      eventAction: "suggest_hit",
      eventLabel: inputValue,
      eventValue: `${label} (${params?.sku}) (product)`,
    });

    saveSearchActionOnStorage({ label, type: "product", url: value });

    window.location.href = value;
  };

  const onHistorySearch = ({ label, url, type }) => {
    dispatchGA4SearchEvent({
      eventAction: "suggest_hit",
      eventLabel: inputValue,
      eventValue: `${label} (history)`,
    });

    saveSearchActionOnStorage({ type, label, url });
    window.location.href = url;
  };

  if (!suggestedTerms?.length) return <></>;

  const SuggestionsLayout = () => {
    switch (autocompleteLayout) {
      case "list":
        return (
          <ListTemplate
            onSuggestionClick={onSuggestionClick}
            suggestedTerms={suggestedTerms}
          />
        );

      case "grid":
        return (
          <GridTemplate
            onHistorySearch={onHistorySearch}
            onSearchValue={onSearchValue}
            onSuggestionClick={onSuggestionClick}
            suggestedTerms={suggestedTerms}
            tenantsWithHistory={tenantsWithHistory}
            clearSearchHistory={clearSearchHistory}
          />
        );

      default:
        return (
          <DefaultTemplate
            onHistorySearch={onHistorySearch}
            onSearchValue={onSearchValue}
            onSuggestionClick={onSuggestionClick}
            suggestedTerms={suggestedTerms}
          />
        );
    }
  };

  return (
    <AutocompleteContainer
      className="bn-search__autocomplete-container"
      isFocused={isFocused}
      isAnchored={anchorsApplied?.length}
    >
      <AutocompleteHeader className="bn-search__autocomplete-header">
        <AutocompleteHeaderText>
          Sugestões para sua pesquisa
        </AutocompleteHeaderText>

        <SeeAllResultsButton
          className={"bn-search__results-btn-top"}
          onSearch={onSearch}
          inputValue={inputValue}
        />
      </AutocompleteHeader>

      <SuggestionsLayout />

      <SeeAllResultsButton
        className={"bn-search__results-btn-bottom"}
        onSearch={onSearch}
        inputValue={inputValue}
      />

      {withDynamicRegion && <div id="bn-autocomplete-dynamic-region"></div>}
    </AutocompleteContainer>
  );
};

export default Autocomplete;
